module.exports = __webpack_public_path__ + "img/gradient-map_cn.71d1e30.jpg";